/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useContext, useEffect, useRef, useState } from "react";
import sass from "./types.module.sass";
import Badge from "components-new/Badge";
import { CreateContext } from "pages/StepPages/StepFour/One/Tables/Tables";
import PortalWrapper from "components-new/PortalWrapper";
import { Button } from "components/shared";
import TypesModal from "pages/StepPages/StepFour/One/Tables/TableNavigate/TypesOfRisksTable/TypesMpdal";
import { fetchRisksTableData } from "pages/StepPages/StepFour/One/Tables/fetch";
import { useParams } from "react-router-dom";
import parentSass from "pages/StepPages/StepFour/One/Tables/TableNavigate/nav.module.sass";
import { ReactComponent as LoadingIcon } from "images/load.svg";
import { RiskTypeResponse } from "libs/apiClient/data-contracts";

interface IModal {
	data: RiskTypeResponse | null;
	active: null | "create" | "edit";
}

const TypesOfRisks = () => {
	/**
	 * данные из контекста, контейнер для прокидывания дополнительных элементов
	 */
	const { container, confirm, currentThread, openConfirm, selectFile, checkTables } = useContext(CreateContext);

	const [load, setLoad] = useState(false);

	/**
	 * стэйт для модалки редактирования строк таблицы
	 */
	const [modal, setModal] = useState<IModal>({ data: null, active: null });

	const params = useParams();

	/**
	 * дынные с сервера для таблицы
	 */
	const [risks, setRisks] = useState<RiskTypeResponse[]>([]);
	const ref = useRef<HTMLInputElement>(null);

	useEffect(() => {
		setLoad(true);
		fetchRisksTableData(Number(params.threadId))
			.then((risks) => {
				setRisks(risks);
				setLoad(false);
			})
			.catch(() => setLoad(false));
		//eslint-disable-next-line
	}, []);

	return (
		<div className={sass.table}>
			<TypesModal
				data={risks}
				replace={(arr) => setRisks(arr)}
				toggle={modal.active}
				active={modal.data}
				close={() => setModal({ active: null, data: null })}
			/>
			{container?.current && (
				<PortalWrapper containerRef={container.current}>
					<input
						ref={ref}
						accept={".docx, application/pdf"}
						onChange={(e) => {
							selectFile(e);
						}}
						id={"file"}
						type={"file"}
						disabled={currentThread?.threatStatus === "APPROVED"}
						hidden={true}
					/>
					<Button
						onClick={() => {
							checkTables({
								type: "model",
								ok: () => {
									ref.current?.click();
								},
							});
						}}
						disabled={currentThread?.threatStatus === "APPROVED"}>
						Загрузить утвержденный документ
					</Button>
				</PortalWrapper>
			)}
			<div className={sass.sticky}>
				<div className={sass.caption}>Таблица 1 – Виды рисков (ущерба) и негативные последствия</div>
				<table>
					<thead>
						<tr>
							<th>Виды риска (ущерба) и обозначения</th>
							<th>Возможные типовые негативные последствия</th>
							<th>Оценка применимости</th>
							<th />
						</tr>
					</thead>
				</table>
			</div>
			<div data-comment-false={true} className={sass.scroll}>
				{load ? (
					<LoadingIcon width={50} height={50} className={parentSass.loading} />
				) : (
					<table>
						<tbody>
							{!!risks.length &&
								risks.map((_, index) => {
									return (
										<tr key={index} onClick={() => (confirm ? openConfirm() : setModal({ data: _, active: "edit" }))}>
											<td>
												{_.type} ({_.name})
											</td>
											<td>{_.consequences}</td>
											<td>
												{_.applicable !== null && _.comment ? (
													<div className={sass.status}>
														<Badge type={_.applicable ? "error" : "success"}>
															{_.applicable ? "Применимо" : "Неприменимо"}
														</Badge>
														<div>
															<p>Комментарий:</p>
															<p>{_.comment}</p>
														</div>
													</div>
												) : (
													<span dangerouslySetInnerHTML={{ __html: "&mdash;" }} />
												)}
											</td>
											<td />
										</tr>
									);
								})}
						</tbody>
					</table>
				)}
			</div>
		</div>
	);
};

export default TypesOfRisks;
